const MAX_WIDTH = '1400px'
const NAV_HEIGHT = '4.4rem'
const SPACER_SMALL = '0.4rem'

export { MAX_WIDTH, NAV_HEIGHT, SPACER_SMALL }
